<span *ngIf="requiresOrg && !hasOrg">Please select an organization...</span>
<span *ngIf="(!requiresOrg || hasOrg) && loading">Loading {{dataName}}...</span>
